export default __webpack_public_path__ + "static/media/Icon_syringe.55382dd3.svg";